<template>
  <div class="RecruitmentProcess">
    <ComTitlte titleEn=" RECRUITING PROCESS" titleZh="招聘流程"></ComTitlte>
    <div class="cont">
      <div class="box_process">
        <div class="item_process" v-for="item in processList" :key="item.index">
          <i :class="['icon_num', 'icon_num' + item.index]"></i>
          <span>
            {{ item.value }}
          </span>
        </div>
      </div>
      <div class="box_tips">
        <p>注意事项:</p>
        <p>
          1.应聘者应如实填写个人有关信息。在公开招聘过程中，我们承诺对应聘者资料严格保密，并仅用于招聘工作；
        </p>
        <p>
          2.我们将以电话方式通知入围人员参加笔试、面试。请保持通讯畅通。招聘各阶段未通过人员不再另行通知。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import ComTitlte from "@/components/common/comTitle";
export default {
  name: "RecruitmentProcess",
  components: { ComTitlte },
  data() {
    return {
      // 流程
      processList: [
        {
          index: 1,
          value: "应聘者发送个人简历至指定邮箱 ",
        },
        {
          index: 2,
          value: "通过审查后应聘者参加笔试 ",
        },
        {
          index: 3,
          value: "根据笔试成绩通知参加面试 ",
        },
        {
          index: 4,
          value: "应聘成功者办理入职手续 ",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
$themeColor: #406cdd;
$themeMinWidth: 1180px;
.RecruitmentProcess {
  width: $themeMinWidth;
  margin: 0 auto;
  position: relative;
  .cont {
    margin: 30px 0 0 0;
    padding: 30px;
    background-color: #ffffff;
    box-shadow: 2px 3px 7px 0px rgba(0, 0, 0, 0.19);
    border-radius: 10px;
    .box_process {
      display: flex;
      justify-content: space-between;
      padding: 0 0 20px 0;
      border-bottom: 1px solid #f5f6f9;
      .item_process {
        display: flex;
        align-items: center;
        .icon_num {
          display: inline-block;
          width: 61px;
          height: 61px;
          &.icon_num1 {
            background: url("../../assets/img/recruit/c_icon1.png") no-repeat;
            background-size: cover;
          }
          &.icon_num2 {
            background: url("../../assets/img/recruit/c_icon2.png") no-repeat;
            background-size: cover;
          }
          &.icon_num3 {
            background: url("../../assets/img/recruit/c_icon3.png") no-repeat;
            background-size: cover;
          }
          &.icon_num4 {
            background: url("../../assets/img/recruit/c_icon4.png") no-repeat;
            background-size: cover;
          }
        }
        span {
          width: 128px;
          font-size: 16px;
          line-height: 30px;
          color: #666666;
          margin: 0 0 0 10px;
        }
        &::after {
          content: "";
          display: block;
          width: 26px;
          height: 26px;
          margin: 0 0 0 40px;
          background: url("../../assets/img/recruit/c_icon_arrow.png") no-repeat;
          background-size: cover;
        }
        &:last-child::after {
          display: none;
        }
      }
    }
    .box_tips {
      padding: 20px 0 0 0;
      p {
        font-size: 14px;
        line-height: 30px;
        color: #999;
      }
    }
  }
}
</style>
